import { Phone, Facebook, MapPin, MessageCircle } from "lucide-react";
import { Reveal } from "./Reveal";

const PHONE = "07348 371266";
const PHONE_TEL = "tel:07348371266";
const WHATSAPP_URL = "https://wa.me/447348371266";
const FB_URL = "https://www.facebook.com/search/top?q=Castleford%20Ecu%20remapping";

const DETAILS = [
  { icon: Phone, label: "WhatsApp / Phone", value: PHONE, testid: "contact-phone", href: PHONE_TEL },
  { icon: Facebook, label: "Facebook", value: "Castleford Ecu remapping", testid: "contact-facebook", href: FB_URL, external: true },
  { icon: MapPin, label: "Location", value: "Castleford, West Yorkshire", testid: "contact-location" },
];

export const Contact = () => {
  return (
    <section id="contact" data-testid="contact-section" className="relative bg-brand-charcoal py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_85%_90%,rgba(230,0,0,0.15),transparent_45%)]" />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8 grid lg:grid-cols-2 gap-16 items-center">
        <div>
          <Reveal>
            <p className="flex items-center gap-3 text-brand-red font-semibold uppercase tracking-[0.35em] text-xs sm:text-sm mb-6">
              <span className="h-px w-10 bg-brand-red" /> Get In Touch
            </p>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-display italic font-extrabold uppercase tracking-tight text-white text-5xl sm:text-6xl md:text-7xl leading-[0.88]">
              Message Us <span className="text-brand-red text-glow-red">Today!</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 text-brand-offwhite/70 text-lg max-w-md">For prices, info &amp; bookings — drop us a message and we'll come to you.</p>
          </Reveal>
          <Reveal delay={0.15}>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-cta-btn"
              className="mt-9 inline-flex items-center gap-3 bg-brand-red hover:bg-brand-redhover text-white font-semibold uppercase tracking-wider text-sm px-9 py-4 rounded-sm box-glow-red transition-[background-color,transform] duration-200 hover:-translate-y-0.5"
            >
              <MessageCircle size={18} strokeWidth={2.4} /> Message Us Now
            </a>
          </Reveal>
        </div>

        <div className="flex flex-col divide-y divide-brand-line border-y border-brand-line">
          {DETAILS.map((d, i) => {
            const Icon = d.icon;
            const inner = (
              <>
                <span className="flex h-12 w-12 shrink-0 items-center justify-center border border-brand-line rounded-sm text-brand-red group-hover:border-brand-red group-hover:box-glow-red transition-[border-color,box-shadow] duration-300">
                  <Icon size={20} strokeWidth={2} />
                </span>
                <div>
                  <p className="text-brand-grey uppercase tracking-widest text-xs mb-1">{d.label}</p>
                  <p className="font-display italic font-bold uppercase text-white text-2xl md:text-3xl leading-none tracking-tight group-hover:text-brand-red transition-colors duration-200">{d.value}</p>
                </div>
              </>
            );
            return (
              <Reveal key={d.label} delay={i * 0.1}>
                {d.href ? (
                  <a
                    href={d.href}
                    data-testid={d.testid}
                    {...(d.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    className="group flex items-center gap-5 py-7"
                  >
                    {inner}
                  </a>
                ) : (
                  <div data-testid={d.testid} className="group flex items-center gap-5 py-7">
                    {inner}
                  </div>
                )}
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-brand-charcoal border-t border-brand-line py-12">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="flex items-baseline gap-2">
          <span className="font-display italic font-extrabold uppercase text-lg tracking-tight text-white">Castleford</span>
          <span className="font-display italic font-bold uppercase text-lg tracking-tight text-brand-red">ECU Remaps &amp; Diagnostics</span>
        </div>
        <p className="text-brand-grey text-sm uppercase tracking-widest text-center">More Power • Better Drive • Better Economy</p>
        <p className="text-brand-grey/60 text-xs">Castleford, West Yorkshire</p>
      </div>
    </footer>
  );
};
